async function s(r, t) {
  const e = await import(
    /* webpackIgnore: true */
    r
  );
  for (const n of t)
    if (e[n] != null)
      return e[n];
}
function i(r) {
  return r.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
const c = (r, t) => {
  const e = i(r).replace(/\\\*/g, ".*");
  return new RegExp("^" + e + "$").test(t);
};
function u(r, t) {
  if (!a(r, t))
    throw new Error(`This URL (${r}) is not allowed. It must have same origin or match: [${(t ?? []).join(", ")}]`);
}
function a(r, t) {
  const e = window.location.origin, n = new URL(r).origin;
  if (n === e)
    return !0;
  if (t == null)
    return !1;
  for (const o of t)
    if (c(o, n))
      return !0;
  return !1;
}
export {
  u as assertSameOriginOrMatch,
  s as importModuleByUrl,
  a as isUrlSameOriginOrMatch
};
//# sourceMappingURL=index.js.map
